module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Global-Landing-Page-w720.63d042a9.webp";